export default __webpack_public_path__ + "static/media/21.cd57e24b.jpg";